"use strict";var r=require("../Guard/isNull.cjs");exports.isPresent=function(s){return void 0!==s&&!r.isNull(s)};
//# sourceMappingURL=isPresent.cjs.map
